// extracted by mini-css-extract-plugin
export default {"brand":"styles_brand__2QleB","main_section":"styles_main_section__Av4+W","left_banner":"styles_left_banner__iqXA3","right_section":"styles_right_section__cUICD"};